<template src="./template.html"></template>
<style src="./styles.scss" lang="scss"></style>

<script>
import { mapActions, mapState } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import { clone, find } from 'lodash'
import { insertEmoji, getPossessive } from '@/helper'
import VEmojiPicker from 'v-emoji-picker'
import FileUploader from '@/components/ui/FileUploader'
import LinkPreview from '@/components/ui/LinkPreview'
import SingleSelectInput from '@/components/ui/SingleSelectInput'

export default {
  name: 'CreatePostOverlay',
  components: {
    FileUploader,
    LinkPreview,
    SingleSelectInput,
    MentionInput: () => import('@/components/ui/MentionInput'),
    VEmojiPicker,
  },
  props: {
    group: Number,
    isOpen: Boolean,
  },
  data() {
    return {
      emojiOpen: false,
      fileUploaderConfig: {
        // Should add file config properties here which different from FileUploader's baseConfig settings
      },
      link: '',
      postOptions: {},
      selectedTab: null,
      topicId: null,
    }
  },
  computed: {
    ...mapState('posts', [
      'authors',
      'pending',
      'pendingPreview',
      'post',
      'selectOptions',
    ]),
    ...mapState('auth', [
      'allow_posts_without_grp_and_topic',
      'settings',
    ]),
    ...mapState('auth', { activeUser: 'user' }),
    ...mapFields('posts', [
      'post.description',
      'post.options',
      'post.files',
      'post.author',
    ]),
    opened: {
      set() {
        this.$emit('onCloseOverlay')
      },
      get() {
        return this.isOpen
      },
    },
  },
  watch: {
    'postOptions.types': {
      handler(val, oldVal) {
        if (val && val?.key !== oldVal?.key) {
          if (val && val.key && !this.topicId) {
            this.$delete(this.postOptions, 'topics')
            this.getTopicOptions(val.key)
          } else {
            this.removeTopics()
          }
        }
      },
      deep: true,
    },
    group: {
      handler() {
        this.setGroup()
      },
      immediate: true,
    },
    topicId: {
      handler() {
        this.setTopic()
      },
      immediate: true,
    },
    async opened(val) {
      if (val) {
        await this.getOverlayOptions()
      }
    },
  },
  created() {
    this.getOverlayOptions()
  },
  methods: {
    ...mapActions('posts', [
      'createPost',
      'getAuthors',
      'getLinkPreview',
      'getOptions',
      'getOptionsForGroup',
      'getTopicOptions',
      'removeMedia',
      'removePreview',
      'removeTopics',
      'updatePostOptions',
    ]),
    selectEmoji(emoji) {
      insertEmoji(emoji, this, '$refs.message.innerValue')
    },
    setGroup() {
      const args = this.getValueByIdentifierAndArgs(
        'types',
        { 'key': this.group, 'value': '' },
      )
      this.onResultUpdate('types', args)
    },
    setTopic() {
      const args = this.getValueByIdentifierAndArgs(
        'topics',
        { 'key': this.topicId, 'value': '' },
      )
      this.onResultUpdate('topics', args)
    },
    toggleTab(type) {
      this.selectedTab = this.selectedTab === type ? null : type
    },
    getPreview(link) {
      this.getLinkPreview(link)
    },
    updateLink(value) {
      this.link = value
    },
    onSubmit() {
      this.createPost().then(status => {
        this.opened = false
      })
    },
    onResultUpdate(id, args) {
      this.$set(this.postOptions, id, args)
      this.updatePostOptions(clone(this.postOptions))
    },
    getValueByIdentifierAndArgs(id, args) {
      const key = args?.key
      const options = this.selectOptions.find(obj => obj.identifier === id)
      if (!key || !options || !options?.properties ||
              !options?.properties.length) {
        return args
      }
      const value = options.properties.find(
        obj => parseInt(obj.key) === parseInt(key),
      )
      return {
        key: key, value: value?.value || '',
      }
    },
    onUpdateAuthor(args) {
      this.author = args
    },
    filesChanged(files) {
      this.files = files
    },
    isDisabled(pending, valid, invalid) {
      if (this.allow_posts_without_grp_and_topic) {
        return invalid
      } else {
        const wrongOptions = !this.postOptions?.topics?.key
        return pending || !valid || invalid || wrongOptions
      }
    },
    getDefaultOption(type) {
      const optionSet = this.selectOptions.find(x => x.identifier === type)
      const checkId = type === 'types' ? this.group : this.topicId
      if (optionSet && checkId) {
        return optionSet.properties.find(option => parseInt(option.key) ===
                                                   parseInt(checkId)) ||
               null
      } else {
        return optionSet.properties.find(option => option.value ===
                                                   this.settings.stream_options.default_post_options[type]) ||
               null
      }
    },
    canPostAsAuthor(user) {
      return Boolean(
        user &&
        find(
          user.permissions,
          p => [
            'superadmin',
            'post_as_author',
          ].indexOf(p) !== -1,
        ),
      )
    },
    async getOverlayOptions() {
      const topicId = this.$route.query.topic_id || this.topicId
      this.topicId = topicId ? parseInt(topicId) : null
      if (this.group) {
        this.getOptionsForGroup(this.group).then(_ => {
          this.checkAndGetAuthors()
        })
      } else {
        this.getOptions().then(_ => {
          this.checkAndGetAuthors()
        })
      }
    },
    checkAndGetAuthors() {
      const asAuthorActive = this.settings?.base_options?.author_function &&
                             this.canPostAsAuthor(this.activeUser)
      if (asAuthorActive) {
        this.getAuthors()
      }
    },
    getPossessive,
  },
}
</script>
